import { Button, Icon } from "web/components"

export default function CustomListActions({
  comparables,
  addComparables,
  onBackToSaved,
}) {
  const comparablesToAdd = comparables.filter((c) => c.selected)
  const hasComparablesToAdd = comparablesToAdd.length !== 0

  async function handleSaveDealComparables() {
    await addComparables(comparablesToAdd)
    onBackToSaved()
  }

  return (
    <Button
      className="gap-1"
      onClick={() => handleSaveDealComparables([])}
      disabled={!hasComparablesToAdd}
    >
      <Icon name="plus" />
      Save
    </Button>
  )
}
